<template>
  <div class="bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('DataRecord') }} > {{ $t('SpeechRecognitionrecord') }}</div>
    <div class="common-table-cnt">
      <div class="search search-container">
        <!-- 查询表单 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline" style="overflow: auto;">
          <el-form-item :label="$t('mechanism')">
            <el-select ref="paramOuSelect" v-model="formInline.ouName" style="width:auto" :placeholder="$t('peaseSelect')" @change="changeParamOu" clearable @visible-change="visibleChange">
              <el-option :value="formInline.ouName" style="height:auto;padding:0px">
                <el-tree ref="paramOuTree" node-key="id" default-expand-all highlight-current :expand-on-click-node="false" :data="ouList" :props="defaultProps" @node-click="selectParamOu">
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('voiceUserName')">
            <el-input v-model="formInline.voiceUserName" clearable :placeholder="$t('voiceUserName')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('serialNumberP2')">
            <el-input v-model="formInline.helmetId" clearable :placeholder="$t('serialNumberP2')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('voiceContent')">
            <el-input v-model="formInline.voiceContent" clearable :placeholder="$t('voiceContent')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Recordtime')" class="datetime">
            <el-date-picker v-model="formInline.startTime" :placeholder="$t('startDate')" type="date" value-format="yyyy-MM-dd HH:mm:ss" :clearable="true" @change="selectDate">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('TO')" class="datetime">
            <el-date-picker v-model="formInline.endTime" :placeholder="$t('endDate')" type="date" value-format="yyyy-MM-dd HH:mm:ss" :clearable="true" @change="selectEndDate">
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" class="serachBtn" @click="getList" v-preventReClick="1000">{{ $t('query') }}</el-button>
            <el-button type="primary" class="serachBtn letter_delet" v-has="'log:data:delete'" v-preventReClick="1000" @click="handleDelet">{{
              $t('batchDelete')
            }}</el-button>
            <el-button type="primary" @click="exportList" :loading="exportLoading" class="serachBtn">{{ $t('exportButton') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-box">
        <!-- table组件 -->
        <Table :data="tableData" v-loading="loading" :columns="columns" :operation="dateOperation" :type="type" ref="tanleAssembly" @getList="getList" @operate="operationEvent" :currentPage="currentPage" :pageSize="pageSize" :playBtnTime="playBtnTime"
          :operationWidth="180" @sortChange="handleSort"></Table>
        <!-- 页脚 -->
        <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="totalData">
        </el-pagination>
      </div>
    </div>
    <audio controls autoplay id="playVoice" ref="audioUrlRef" :src="fileUrl" @canplay="getDuration" style="visibility: hidden;"></audio>
    <!-- 新增弹窗 -->
    <el-dialog :title="$t('createVoice')" :visible.sync="dialogVoice" width="600px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :append-to-body="true">
      <el-form :model="addVoiceData">
        <div class="settingDialog">
          <el-form-item :label="$t('voiceUserName')" :label-width="formLabelWidth" :required="true">
            <el-input v-model="addVoiceData.voiceUserName" autocomplete="off" :placeholder="$t('voiceUserName')" clearable></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createVoice()" v-preventReClick="1000">保存</el-button>
        <el-button @click="quitCreateVoice()">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Table from '@/components/NewTable'
import { voiceCreateByLogId } from '@/api/voiceRecognit'
import { voiceDetectPage, voiceDetectDelete } from '@/api/log'
import { datetimeFullZero, datetimeFull } from '@/api/common'
import { getOus } from '@/api/UserList'
import { getExportVoiceDetect } from '@/api/log/log'
import { downloadBlobExcel } from '@/util/common'
import { beforeWeekDate, nowDate,getDaysDiff } from '@/util/date'
export default {
  data() {
    return {
      ouList: [],
      formInline: {
        ouName: '',
        ouId: '',
        //查询表单字段
        helmetId: '',
        voiceUserName: '',
        startTime: beforeWeekDate() + ' 00:00:00',
        endTime: nowDate() + ' 23:59:59',
        voiceContent: '',
      },
      currentPage: 1,
      pageSize: 10,
      totalData: 0,
      columns: [],
      dateOperation: [],
      tableData: [],
      fileType: [],
      childOperats: [],
      childoperationMap: [],
      // 用于批量删除 公共组件类型判断
      type: 'Voiceprint',
      fileUrl: '',
      formLabelWidth: '160px',
      dialogVoice: false,
      addVoiceData: {
        voiceUserName: '',
        voiceUrl: '',
      },
      // 秒来计算要播放的时间
      playTime: 0,
      clearaudioTime: null,
      playBtnTime: 0,
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      exportLoading: false,
      showTip: false,
      // 遮罩层
      loading: false,
    }
  },
  components: {
    Table,
  },
  methods: {
    //导出列表
    exportList() {
      if(this.totalData >= 100000) {
        this.$message({
          type: 'warning',
          message: this.$t('maxFile'),//提示用户数据量过大，无法导出
        })
        return
      }
      this.exportLoading = true
      let startTime = ''
      let endTime = ''
      if (this.formInline.startTime) {
        startTime = datetimeFullZero(this.formInline.startTime)
      }
      if (this.formInline.endTime) {
        endTime = datetimeFull(this.formInline.endTime)
      }
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        startTime: startTime,
        endTime: endTime,
        ouId: this.formInline.ouId,
        ouName: this.formInline.ouName,
        helmetId: this.formInline.helmetId,
        voiceUserName: this.formInline.voiceUserName,
        voiceContent: this.formInline.voiceContent,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      getExportVoiceDetect(params).then(res => {
        this.exportLoading = false
        downloadBlobExcel(res, this.$t('SpeechRecognitionrecord') + '.xls')
      })
    },
     // 排序
     handleSort(data) {
      this.formInline.sortColName = !data.order ? null : data.prop
      this.formInline.useAsc = data.order=== "descending" ? 0 : 1
      this.getList()
    },
    // 选中过滤条件机构，过滤用户
    selectParamOu(data) {
      this.formInline.ouName = data.name
      this.formInline.ouId = data.id
      this.$refs.paramOuSelect.blur()
    },
    // 获取组织机构
    getOusTree() {
      getOus().then((res) => {
        if (res.state === 0) {
          this.ouList = res.data
        }
      })
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    // 清空过滤条件机构，过滤用户
    changeParamOu(data) {
      if (!data) {
        this.formInline.ouId = null
        this.formInline.ouName = null
        this.$nextTick(() => {
          this.$refs.paramOuTree.setCurrentKey(null)
        })
      }
    },
    // 选择日期时触发
    selectDate(e) {
      if (e === null) {
        this.formInline.startTime = ''
      }
    },
    selectEndDate(e) {
      if (e === null) {
        this.formInline.endTime = ''
      }
    },
    getDuration() {
      this.playBtnTime = this.$refs.audioUrlRef.duration
      this.countDown(this.playBtnTime)
    },
    // 倒计时语音动画
    countDown(resetTime) {
      if (resetTime > 0) {
        resetTime--
        this.clearaudioTime = setTimeout(() => {
          this.countDown(resetTime)
        }, 1000)
      } else {
        clearTimeout(this.clearaudioTime)
        this.playBtnTime = 0
      }
    },
    handleDelet() {
      this.$refs.tanleAssembly.handleDeletList()
    },
    // 操作按钮
    operationEvent(row, value, index) {
      if (row.type === 'delect') {
        this._deleteOperationLog(row)
      } else if (row.type === 'play') {
        this.playVoice(row.value)
      } else if (row.type === 'create') {
        if (row.value.voiceUrl) {
          this.addVoiceData.id = row.value.id
          this.dialogVoice = true
        } else {
          this.$message({
            type: 'error',
            message: this.$t('errorVoiceCreate'),
          })
        }
      }
    },
    //  删除后台操作日志
    _deleteOperationLog(row) {
      this.$confirm(this.$t('deleteTip'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let params = []
        params.push(row.value.id)
        voiceDetectDelete(params).then((res) => {
          if (res.state === 0) {
            this.$message({
              type: 'success',
              message: this.$t('deleteSuccess'),
            })
            this._getOperations()
          }
        })
      })
    },
    // 播放声音
    playVoice(row) {
      if (row.voiceUrl) {
        document.getElementById('playVoice').src = row.voiceUrl
      } else {
        this.$message({
          type: 'error',
          message: this.$t('errorVoicePlay'),
        })
      }
    },
    // 使用录音注册为声纹
    createVoice() {
      // 判断表单是否填入内容 提示
      if (!this.addVoiceData.voiceUserName) {
        this.$message({
          type: 'error',
          message: this.$t('errorVoiceUserName'),
        })
        return
      }
      let param = {
        logId: this.addVoiceData.id,
        voiceUserName: this.addVoiceData.voiceUserName,
      }
      // 输入完成后请求 添加 接口
      voiceCreateByLogId(param).then((res) => {
        if (res.state === 0) {
          this.$message({
            type: 'success',
            message: this.$t('createSuccess'),
          })
          this.quitCreateVoice()
        }
      })
    },
    // 取消使用录音注册为声纹
    quitCreateVoice() {
      this.addVoiceData = {
        voiceUserName: '',
        id: '',
      }
      this.dialogVoice = false
    },
    handleSizeChange(val) {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.pageSize = val
      this._getOperations()
    },
    handleCurrentChange(val) {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = val
      this._getOperations()
    },
    // 查询
    getList() {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = 1
      this.handleSearch()
    },
    handleSearch() {
      let daysDiff = getDaysDiff(this.formInline.startTime, this.formInline.endTime)
      if (!this.showTip && daysDiff > 30) {
        this.$confirm(this.$t('searchDataTip'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        })
          .then(() => {
            this._getOperations()
            this.showTip = true
          })
          .catch(() => {
            this.showTip = false
            return
          })
      } else {
        this._getOperations()
      }
    },
    // 获取操作数据
    _getOperations() {
      this.loading = true
      let startT = ''
      let endT = ''
      if (this.formInline.startTime) {
        startT = datetimeFullZero(this.formInline.startTime)
      }
      if (this.formInline.endTime) {
        endT = datetimeFull(this.formInline.endTime)
      }
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        startTime: startT,
        endTime: endT,
        ouId: this.formInline.ouId,
        ouName: this.formInline.ouName,
        helmetId: this.formInline.helmetId,
        voiceUserName: this.formInline.voiceUserName,
        voiceContent: this.formInline.voiceContent,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      voiceDetectPage(param).then((res) => {
        if (res.state === 0) {
          this.loading = false
          this.tableData = res.value.list
          this.totalData = res.value.total
        }
      })
    },
    // 基础配置数据
    basicConfig() {
      this.columns = [
        {
          attrName: 'ouName',
          label: this.$t('mechanism'),
          sort: 'ouName',
        },
        {
          attrName: 'helmetId',
          label: this.$t('serialNumberP2'),
          sort: 'helmetId',
        },
        {
          attrName: 'voiceUserName',
          label: this.$t('voiceUserName'),
          sort: 'voiceUserName',
        },
        {
          attrName: 'voiceContent',
          label: this.$t('voiceContent'),
          sort: 'voiceContent',
        },
        {
          attrName: 'logTimestamp',
          label: this.$t('Recordtime'),
          width: '180',
          align: 'center',
          sort: 'logTimestamp',
        },
      ]
      this.dateOperation = [
        {
          operateName: this.$t('play'),
          type: 'play',
          IsHad: '',
          class: 'editClick',
          playicon: require('@/icon/vioce.png'),
        },
        {
          operateName: this.$t('createVoice'),
          type: 'create',
          IsHad: '',
          class: 'editClick',
        },
        {
          operateName: this.$t('delete'),
          type: 'delect',
          IsHad: 'log:data:voiceDetect',
          class: 'editClick',
        },
      ]
    },
  },
  created() {
    this.basicConfig()
    this._getOperations()
    this.getOusTree()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl';

>>>.el-table {
  height: 640px !important;
  min-height: 500px !important; /* no */
  overflow: auto;
}

>>>.el-popper {
  min-width: 200px !important;
}
>>> .el-tree-node__content
  font-weight: 400
  color: var(--new-el-select-dropdown-item)

.letter_delet {
  margin-left: 10px;
}

audio {
  visibility: hidden;
}

.bg-contain .common-table-cnt /deep/ .el-table {
  height: 624px !important;
}

.common-blue-contain {
  .el-pagination {
    margin-top: 18px;
  }
}
>>> .el-tree
  height 100%
  background: var(--new-tree-bg)
  color: var(--new-el-select-dropdown-item)
>>>.el-tree-node
  height: 100%
>>>.el-tree-node__content:hover .editBtn
    display inline-block
>>>.el-input__prefix, >>>.el-input__suffix
  color #fff
>>> .el-tree-node__content
  font-weight: 400
  color: var(--new-el-select-dropdown-item)
.el-select-dropdown
  .el-select-dropdown__list
    .el-select-dropdown__item.hover
      background-color var(--new-tree-bg)
</style>
